"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Upnid = void 0;
const react_1 = __importDefault(require("react"));
const Upnid = ({ size, color }) => {
    return (react_1.default.createElement("svg", { width: size, height: size, viewBox: "0 0 57 57", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", { d: "M49.998 34.964a29.273 29.273 0 0 1-41.586-.056 29.388 29.388 0 0 0 8.905 1.384h.607A29.045 29.045 0 0 1 4.188 29.49 29.493 29.493 0 0 1 .928 7a46.835 46.835 0 0 0 22.3 23.569 19.024 19.024 0 0 0 2.557 4.471c.454.559.955 1.078 1.497 1.553a6.526 6.526 0 0 0 4.623 1.667c3.543-.227 4.888-.7 5.835.265 0 0 .227-1.135-1.402-1.704-.341-.928-.417-1.156-2.14-1.987-.53-.245-1.193-.569-2.066-.948.929.246 1.895.455 2.843.645a47.26 47.26 0 0 0 8.885.852 50.352 50.352 0 0 0 6.14-.417", fill: "#3B86FF" })));
};
exports.Upnid = Upnid;
